import { useQuery } from "@tanstack/react-query";
import { blogService } from "@/services/blog";
import { readBlogSsrData } from "@/shared/blog/ssrData";
import { blogKeys } from "./queryKeys";

/** Detalhe público de um post pelo slug. Retorna null se não publicado. */
export const usePublishedPost = (slug: string | undefined) =>
  useQuery({
    queryKey: blogKeys.publishedDetail(slug ?? ""),
    queryFn: () => blogService.getPublishedBySlug(slug as string),
    enabled: Boolean(slug),
    // Primeiro render com o que o SSR já entregou: sem esqueleto e sem
    // depender da API para mostrar a página (ver src/shared/blog/ssrData.ts).
    // A busca segue acontecendo em segundo plano e atualiza se algo mudou.
    initialData: () => {
      const ssr = readBlogSsrData();
      return ssr?.kind === "post" && ssr.slug === slug ? ssr.post : undefined;
    },
  });
